/**
 * File Name          : choose-lesson.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';
import { DatasnapUnit, DatasnapLevel, UNITS } from '../../models/lessons.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DatasnapDeviceService } from '../../services/datasnap-device.service';
import { ScreenserviceService } from '../../services/screenservice.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-choose-lesson',
  standalone: true,
  imports: [CommonModule, DxButtonModule],
  templateUrl: './choose-lesson.component.html',
  styleUrl: './choose-lesson.component.scss'
})
export class ChooseLessonComponent {
  unitId!: string;
  unit: DatasnapUnit|undefined;
  levelId!: string;
  level: DatasnapLevel |undefined;
  
  constructor(private activatedRoute: ActivatedRoute, private datasnapDeviceService: DatasnapDeviceService, private router: Router, public screenservice: ScreenserviceService) {

  }
  ngOnInit() {
      // Subscribe to router events to detect navigation changes
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.updateFromRoute();
      });
  
      // Initial load
      this.updateFromRoute();
  }

  private updateFromRoute() {
    // Access the deepest child route to get all params
    let child = this.activatedRoute;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else {
        this.unitId = this.activatedRoute.snapshot.paramMap.get('unitId') ?? '';
        this.unit = UNITS.find(l => l.id === this.unitId);
        this.levelId = this.activatedRoute.snapshot.paramMap.get('levelId') ?? '';
        this.level = this.unit?.levels.find(l => l.id === this.levelId);
          console.log('unit id is ', this.unit?.id, ' level id is ', this.level?.id)

        if(!this.unit || !this.level) {
          this.router.navigate(['home'])
        }
        
        break;
      }
    }
  }

  openLesson = (lessonId: string) => {
    this.router.navigate(['/home', this.unitId, this.levelId, lessonId]);
  }
}
